export default __webpack_public_path__ + "static/media/first_person.1546bc32.svg";